import classnames from 'classnames';
import React from 'react';

import SkeletonBlock from 'dpl/common/design_system/SkeletonBlock';
import { isLessThanBreakpoint } from 'dpl/util/grid';

const IS_LT_MD = isLessThanBreakpoint('md');

export default function BreederProfileAdoptionProcessSkeleton() {
  return (
    <section className="BreederProfileAdoptionProcessSkeleton bg-subtle-light-gray pv12 pv20-md">
      <div className="container-xxl">
        <div className="flex flex-column gap-32 md:gap-96">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-32 md:gap-96">
            <div>
              <SkeletonBlock
                className="font-24 md:font-40 mb6 mb8-md"
                height="1em"
                width="12em"
              />
              <div className="flex flex-column gap-8">
                <SkeletonBlock className="font-16 md:font-18" height="1em" />
                <SkeletonBlock className="font-16 md:font-18" height="1em" />
                {IS_LT_MD && (
                  <SkeletonBlock className="font-16 md:font-18" height="1em" />
                )}
                <SkeletonBlock
                  className="font-16 md:font-18 mb2 mb3-md"
                  height="1em"
                  width="80%"
                />
                <SkeletonBlock className="font-16 md:font-18" height="1em" />
                <SkeletonBlock
                  className="font-16 md:font-18"
                  height="1em"
                  width="90%"
                />
              </div>
            </div>
            <SkeletonBlock
              height={IS_LT_MD ? '144px' : '200px'}
              width={IS_LT_MD ? '140px' : '192px'}
            />
            <div>
              <SkeletonBlock
                className="font-24 md:font-32 mb6 mb8-md"
                height="1em"
                width="4em"
              />
              <div className="flex flex-column gap-8">
                <SkeletonBlock className="font-16 md:font-18" height="1em" />
                <SkeletonBlock
                  className="font-16 md:font-18 mb2 mb3-md"
                  height="1em"
                  width="50%"
                />
                <SkeletonBlock className="font-16 md:font-18" height="1em" />
                <SkeletonBlock className="font-16 md:font-18" height="1em" />
                {IS_LT_MD && (
                  <SkeletonBlock className="font-16 md:font-18" height="1em" />
                )}
                <SkeletonBlock
                  className="font-16 md:font-18"
                  height="1em"
                  width="75%"
                />
              </div>
            </div>
            <div>
              <SkeletonBlock
                className="font-24 md:font-32 mb6 mb8-md"
                height="1em"
                width="10em"
              />
              <div className="flex flex-column gap-8">
                <SkeletonBlock className="font-16 md:font-18" height="1em" />
                <SkeletonBlock className="font-16 md:font-18" height="1em" />
                <SkeletonBlock className="font-16 md:font-18" height="1em" />
              </div>
              <div className="flex gap-16 br3 ba b--light-gray pv4 ph4 mt6 mt8-md">
                <SkeletonBlock className="br-100" height="36px" width="36px" />
                <div className="flex-auto flex flex-column justify-center gap-8">
                  <SkeletonBlock
                    className="font-16"
                    height="1em"
                    width={IS_LT_MD ? '100%' : '80%'}
                  />
                  {IS_LT_MD && (
                    <SkeletonBlock
                      className="font-16"
                      height="1em"
                      width="80%"
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
          <div>
            <SkeletonBlock
              className="font-24 md:font-32 mb6 mb8-md"
              height="1em"
              width="8em"
            />
            <ul className="grid grid-cols-1 md:grid-cols-2 gap-96">
              {(IS_LT_MD
                ? [[8, 10, 10, 4]]
                : [
                    [8, 10],
                    [10, 4]
                  ]
              ).map((column, colIndex) => (
                <li key={colIndex}>
                  <ul className="flex flex-column gap-32 md:gap-56">
                    {column.map((width, index) => (
                      <li key={index}>
                        <div className="flex flex-column flex-md-row items-center-ns gap-16 md:gap-12 mb3 mb6-md">
                          <SkeletonBlock
                            className="br-100"
                            height="32px"
                            width="32px"
                          />
                          <SkeletonBlock
                            height="1em"
                            width={`${width}em`}
                            className="font-16 md:font-24"
                          />
                        </div>
                        <ul className="flex flex-column">
                          {[22, 20, 20].map((lineWidth, i) => (
                            <li
                              key={i}
                              className={classnames('flex items-center', {
                                'bt b--default pt4': i > 0,
                                pb4: i < 3
                              })}
                            >
                              <SkeletonBlock
                                className="font-16 md:font-18"
                                height="1em"
                                width={`${lineWidth}em`}
                              />
                            </li>
                          ))}
                        </ul>
                      </li>
                    ))}
                  </ul>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
